import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import store from '../store';
import UnAuthenticatedBase from '../views/UnAuthenticatedBase.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import CreateAccount from '../views/CreateAccount.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        component: UnAuthenticatedBase,
        children: [
            {
                path: '',
                name: 'login',
                component: Login
            },
            {
                path: 'ForgotPassword',
                component: ForgotPassword
            },
            {
                path: 'CreateAccount',
                component: CreateAccount
            }
        ]
    },
    {
        path: '/Dashboard',
        component: Dashboard,
        meta: { requiredLoggedIn: true }
    },
    {
        path: '*',
        redirect: '/'
    }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
    const requiredLoggedIn = to.matched
        .some((route) => route.meta.requiredLoggedIn);

    if (to.name == 'login' && store.state.loggedIn) {
        next({
            path: '/Dashboard'
        })
    }

    if (requiredLoggedIn && !store.state.loggedIn) {
        next({
            path: '/',
            query: {
                next: to.path
            }
        })
    }

    next();
});

export default router;
